var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[_vm.$bem(), 'rel']},[_vm._t("activator",null,null,_vm.listeners),_c('div',{ref:"content",staticClass:"hidden"},[_vm._t("default")],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }